import * as React from 'react';
import { Grid, Page } from 'tabler-react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { useAPI } from '../../ApiCalls/useAPI';
import Methods from '../../ApiCalls/apiMethods';
import './LiveClassroom.scss';

class LiveClassroom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            postId: null,
            session: null
        };
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick = (event) => {
        // console.log(event.type);
    };
    checkResponse(data) {
        this.setState({ data: data });
    }
    getData() {
        const { getLiveclassroom } = useAPI();
        getLiveclassroom()
            .then((response) => {
                // console.log(response, 'Liveclassroom');
                this.checkResponse(response);
            })
            .catch((error) => console.error(error));
    }
    componentDidMount() {
        this.getData();
    }

    render() {
        let ui;
        if (this.state.data != null) {
            if (this.state.data.liveclass === 'true') {
                ui = <Cameras data={this.state.data} />;
            } else {
                ui = <NoCameras />;
            }
        } else {
            ui = <NoCameras />;
        }
        return <Page.Content>{ui}</Page.Content>;
    }
}

class Cameras extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            img1: '',
            img2: '',
            random: ''
        };
    }
    getData() {
        const { getLiveclassroom } = useAPI();
        getLiveclassroom().then((response) => {
            // console.log(response, 'Liveclassroom');
            this.checkResponse(response);
        });
    }
    setRandom() {
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
        var randomstring = '';
        for (var i = 0; i < 7; i++) {
            var rnum = Math.floor(Math.random() * characters.length);
            randomstring += characters.substring(rnum, rnum + 1);
        }
        this.setState({ random: randomstring });
    }
    checkResponse(data) {
        this.setState({ data: data });
    }
    componentDidMount() {
        let sec = null;
        sec = this.props.data;
        this.setState({
            img1: sec.classdetails.url1,
            img2: sec.classdetails.url2
        });
    }
    render() {
        let sec = null;
        sec = this.props.data;
        let img1 = (
            <img
                src={
                    Methods.global_url +
                    '/cctv/cctv1.php?id=' +
                    (this.state.img1 ? this.state.img1 : 1) +
                    '&rand=' +
                    this.state.random
                }
                alt="classroom camera 1"
            />
        );
        let img2 = (
            <img
                src={
                    Methods.global_url +
                    '/cctv/cctv1.php?id=' +
                    (this.state.img2 ? this.state.img2 : 1) +
                    '&rand=' +
                    this.state.random
                }
                alt="classroom camera 2"
            />
        );
        return (
            <div className="container" onClick={this.handleClick}>
                <div
                    className="m-0 mb-4"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Live Classroom</div>
                </div>
                <div id="card1" className="card">
                    <div className="table-responsive">
                        <table className="table card-table table-hover table-outline table-vcenter text-nowrap">
                            <thead className="">
                                <tr className="">
                                    <th className="text-center">Section</th>
                                    <th className="text-center">Faculty</th>
                                    <th className="text-center">Subject</th>
                                </tr>
                            </thead>
                            <tbody className="">
                                <tr className="">
                                    <td className="text-center">
                                        {sec.classdetails.section}
                                    </td>
                                    <td className="text-center">
                                        {sec.classdetails.faculty}
                                    </td>
                                    <td className="text-center">
                                        {sec.classdetails.subject}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div id="mobilecard1" className="card">
                    <div className="table-responsive">
                        <table className="table card-table table-hover table-outline table-vcenter text-nowrap">
                            <tbody className="">
                                <tr className="">
                                    <td>
                                        <b>Section</b>
                                    </td>
                                    <td className="text-right">
                                        {sec.classdetails.section}
                                    </td>
                                </tr>
                                <tr className="">
                                    <td>
                                        <b>Faculty</b>
                                    </td>
                                    <td className="text-right">
                                        {sec.classdetails.faculty}
                                    </td>
                                </tr>
                                <tr className="">
                                    <td>
                                        <b>Subject</b>
                                    </td>
                                    <td className="text-right">
                                        {sec.classdetails.subject}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <Grid.Row>
                    <Grid.Col md={6} xl={6}>
                        <div id="cam1" className="card">
                            <div className="card-header">
                                <h3 className="card-title">Cam 1</h3>
                                <div
                                    id="close-btn1"
                                    className="card-options"
                                    style={{ display: 'none' }}
                                >
                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => {
                                            document
                                                .getElementById('cam1')
                                                .classList.remove(
                                                    'card-fullscreen'
                                                );
                                            document.getElementById(
                                                'close-btn1'
                                            ).style.display = 'none';
                                            document.getElementById(
                                                'play-btn1'
                                            ).style.display = 'block';
                                            clearInterval(this.timerId);
                                        }}
                                    >
                                        <i className="fe fe-x" />
                                    </button>
                                </div>
                            </div>
                            <div className="card-body video_thumbnail">
                                {img1}
                                <div
                                    id="play-btn1"
                                    className="play-btn"
                                    onClick={() => {
                                        document
                                            .getElementById('cam1')
                                            .classList.add('card-fullscreen');
                                        document.getElementById(
                                            'close-btn1'
                                        ).style.display = 'block';
                                        document.getElementById(
                                            'play-btn1'
                                        ).style.display = 'none';
                                        this.timerId = setInterval(() => {
                                            this.setRandom();
                                            // console.log('rerendered');
                                        }, 3000);
                                    }}
                                >
                                    <i className="fe fe-play play-icon" />
                                </div>
                            </div>
                        </div>
                    </Grid.Col>
                    <Grid.Col md={6} xl={6}>
                        <div id="cam2" className="card">
                            <div className="card-header">
                                <h3 className="card-title">Cam 2</h3>
                                <div
                                    id="close-btn2"
                                    className="card-options"
                                    style={{ display: 'none' }}
                                >
                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() => {
                                            document
                                                .getElementById('cam2')
                                                .classList.remove(
                                                    'card-fullscreen'
                                                );
                                            document.getElementById(
                                                'close-btn2'
                                            ).style.display = 'none';
                                            document.getElementById(
                                                'play-btn2'
                                            ).style.display = 'block';
                                            clearInterval(this.timerId);
                                        }}
                                    >
                                        <i className="fe fe-x" />
                                    </button>
                                </div>
                            </div>
                            <div className="card-body video_thumbnail">
                                {img2}
                                <div
                                    id="play-btn2"
                                    className="play-btn"
                                    onClick={() => {
                                        document
                                            .getElementById('cam2')
                                            .classList.add('card-fullscreen');
                                        document.getElementById(
                                            'close-btn2'
                                        ).style.display = 'block';
                                        document.getElementById(
                                            'play-btn2'
                                        ).style.display = 'none';
                                        this.timerId = setInterval(() => {
                                            this.setRandom();
                                            // console.log('rerendered');
                                        }, 3000);
                                    }}
                                >
                                    <i className="fe fe-play play-icon" />
                                </div>
                            </div>
                        </div>
                    </Grid.Col>
                </Grid.Row>
                <div id="mobcam1" className="card">
                    <div className="card-header">
                        <h3 className="card-title">Cam 1</h3>
                        <div
                            id="mob-close-btn1"
                            className="card-options"
                            style={{ display: 'none' }}
                        >
                            <button
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                    document
                                        .getElementById('mobcam1')
                                        .classList.remove('card-fullscreen');
                                    document.getElementById(
                                        'mob-close-btn1'
                                    ).style.display = 'none';
                                    document.getElementById(
                                        'mob-play-btn1'
                                    ).style.display = 'block';
                                    clearInterval(this.timerId);
                                }}
                            >
                                <i className="fe fe-x" />
                            </button>
                        </div>
                    </div>
                    <div className="card-body video_thumbnail">
                        {img1}
                        <div
                            id="mob-play-btn1"
                            className="play-btn"
                            onClick={() => {
                                document
                                    .getElementById('mobcam1')
                                    .classList.add('card-fullscreen');
                                document.getElementById(
                                    'mob-close-btn1'
                                ).style.display = 'block';
                                document.getElementById(
                                    'mob-play-btn1'
                                ).style.display = 'none';
                                this.timerId = setInterval(() => {
                                    this.setRandom();
                                    // console.log('rerendered');
                                }, 3000);
                            }}
                        >
                            <i className="fe fe-play play-icon" />
                        </div>
                    </div>
                </div>
                <div id="mobcam2" className="card">
                    <div className="card-header">
                        <h3 className="card-title">Cam 2</h3>
                        <div
                            id="mob-close-btn2"
                            className="card-options"
                            style={{ display: 'none' }}
                        >
                            <button
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                    document
                                        .getElementById('mobcam2')
                                        .classList.remove('card-fullscreen');
                                    document.getElementById(
                                        'mob-close-btn2'
                                    ).style.display = 'none';
                                    document.getElementById(
                                        'mob-play-btn2'
                                    ).style.display = 'block';
                                    clearInterval(this.timerId);
                                }}
                            >
                                <i className="fe fe-x" />
                            </button>
                        </div>
                    </div>
                    <div className="card-body video_thumbnail">
                        {img2}
                        <div
                            id="mob-play-btn2"
                            className="play-btn"
                            onClick={() => {
                                document
                                    .getElementById('mobcam2')
                                    .classList.add('card-fullscreen');
                                document.getElementById(
                                    'mob-close-btn2'
                                ).style.display = 'block';
                                document.getElementById(
                                    'mob-play-btn2'
                                ).style.display = 'none';
                                this.timerId = setInterval(() => {
                                    this.setRandom();
                                    // console.log('rerendered');
                                }, 3000);
                            }}
                        >
                            <i className="fe fe-play play-icon" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
class NoCameras extends React.Component {
    render() {
        return (
            <div>
                <div
                    className="m-2"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Live Classroom</div>
                </div>
                <div className="card">
                    <div className="card-body" style={{ textAlign: 'center' }}>
                        Cameras not available
                    </div>
                </div>
            </div>
        );
    }
}
export default LiveClassroom;
